//解码
let jGlobalSetting=''
if(process.env.NODE_ENV == 'production' && GlobalSetting){
    jGlobalSetting=JSON.parse(window.atob(GlobalSetting))
}

let assetsUrl=(process.env.NODE_ENV == 'development')?process.env.BASE_ASSETSURL:jGlobalSetting.BASE_ASSETSURL   //图片环境
let BASE_ASSETSURL_FILE=(process.env.NODE_ENV == 'development')?process.env.BASE_ASSETSURL_FILE:jGlobalSetting.BASE_ASSETSURL_FILE   //BASE_ASSETSURL_FILE
let MasterSecret=(process.env.NODE_ENV == 'development')?process.env.BASE_MasterSecret:jGlobalSetting.BASE_MasterSecret   //MasterSecret
let AppMerchantId=(process.env.NODE_ENV == 'development')?process.env.BASE_AppMerchantId:jGlobalSetting.BASE_AppMerchantId   //AppMerchantId
let AppEstateId=(process.env.NODE_ENV == 'development')?process.env.BASE_AppEstateId:jGlobalSetting.BASE_AppEstateId   //AppEstateId
let Version=(process.env.NODE_ENV == 'development')?process.env.BASE_Version:jGlobalSetting.BASE_Version   //Version
let ClientType=(process.env.NODE_ENV == 'development')?process.env.BASE_ClientType:jGlobalSetting.BASE_ClientType   //ClientType
let Language=(process.env.NODE_ENV == 'development')?process.env.BASE_Language:jGlobalSetting.BASE_Language   //Language
let md5Code=(process.env.NODE_ENV == 'development')?process.env.BASE_md5Code:jGlobalSetting.BASE_md5Code   //md5Code
let dealMsgModuleType=['DRManage','ReportRepair','CSBMManageUpdate','CSBMManageFile']//通知，移動端需要跳轉pc的MsgModuleType

export default{
    isShowLog:true,
    assetsUrl,
    BASE_ASSETSURL_FILE,
    UserAppCss:'#B0294A',
    MasterSecret,
    AppMerchantId,
    AppEstateId,
    Version,
    ClientType,
    Language,
    md5Code,
    dealMsgModuleType,
    Regularexpression:{
        phone:/^1(3[0-9]|4[5,7]|5[0,1,2,3,5,6,7,8,9]|6[2,5,6,7]|7[0,1,7,8]|8[0-9]|9[1,8,9])\d{8}$/,
        email:/^([a-zA-Z0-9_\.-]+)@([\da-z\.-]+)\.([A-Za-z\.]{1,8})$/,
        // mobile:/(^[0-9]{3,4}\-[0-9]{3,15}$)|(^[0-9]{8,15}$)/,
        // mobile:/(^[a-zA-Z0-9_-]{3,4}\-[0-9]{3,15}$)|(^[0-9]{8,15}$)/,
        // mobile:/^(?=.{8,15}$)/
        mobile:/^.{8,15}$/
    },
}



// WEBPACK FOOTER //
// ./src/config.js